export { default } from './PortfolioPage';


// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/index.js